import { PRIVATE } from '@/plugins/acl/const'

const dashboard = [
  {
    path: '/dashboards/crm',
    name: 'dashboard-crm',
    component: () => import('@/views/dashboards/crm/Crm.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.DASHBOARD,
    },
  },
  {
    path: '/dashboards/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboards/analytics/Analytics.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.DASHBOARD,
    },
  },
  {
    path: '/dashboards/eCommerce',
    name: 'dashboard-eCommerce',
    component: () => import('@/views/dashboards/ecommerce/Ecommerce.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.DASHBOARD,
    },
  },
  {
    path: '/dashboard/',
    name: 'dashboard',
    component: () => import('@/views/dashboards/testing/Dashboard.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.DASHBOARD,
    },
  },
]

export default dashboard
